import * as React from "react";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";

export default function TreeViewComponent({ siteid, setSelectedLocation, tagsIds, listTags, selectedApp, appChangeKey}) {
  const { siteTagList } = useSelector((state) => state?.sitesReducer);
  const cvAppList = useSelector((state) => state.cvAppReducer.cvAppList) || [];
  const widgetConfig = useSelector((state) => state.widgetReducer.widgetConfig);
  const [tagid, setTagId] = React.useState();
  

  const appNameMap = new Map(cvAppList.map((app) => [app.id, app.name]));
  const widgetConfig_result = (widgetConfig || []).reduce((acc, currentWidget) => {
    const appId = currentWidget?.content?.appName;
    const cvappname = appNameMap.get(appId);
    const location = currentWidget?.content?.location;
    // Safeguard: Only push if the app name and location actually exist
    if (cvappname && location) {
      acc[cvappname] = acc[cvappname] || [];
      acc[cvappname].push(location);
    }
    return acc;
  }, {});



  React.useEffect(() => {
    setTagId('');
    setSelectedLocation(null);
  }, [appChangeKey]);

  const handleItemSelectionToggle = (event, itemId) => {
    if (event.target.checked) {
      setSelectedLocation(itemId);
      setTagId(itemId);
    } else {
      setSelectedLocation(null);
      setTagId('');
    }
  };
  return (
    <Box sx={{ minWidth: 290 }}>
      <SimpleTreeView
        // checkboxSelection
        // onItemSelectionToggle={handleItemSelectionToggle}
      >
        {siteTagList?.sites.map((site) => {
          if(listTags?.includes(site.id)) {
            return (
              <TreeItem style={{marginLeft: '-25px'}} itemId={site.id} label={
                listTags.includes(site.id) ?
                <div>
                  <input type="checkbox"
                  data-testid= 'dashboard_widgetAddModalLocationSiteCheckbox'
                  onChange={(e) => 
                    handleItemSelectionToggle(e, site.id)
                  }
                  checked={site.id === tagid}
                  value={site.id}
                  disabled={(selectedApp?.name && widgetConfig_result[selectedApp.name]?.includes(site.id))  || !tagsIds.includes(siteid) }
                  style={{
                    marginRight: "10px",
                    width: "20px",
                    height: "20px",
                    borderColor: "#6F7171",
                  }} /> {site.name}
                </div>
                : site.name}></TreeItem> );
          }
        })
        }
        {siteTagList?.floors.map((floor) => {
          if (floor?.tagids?.includes(siteid) && listTags?.includes(floor.id)) {
            return (
              <TreeItem itemId={floor.id} label={
                tagsIds.includes(floor.id) ?
                <div>
                  <input type="checkbox"
                  data-testid= 'dashboard_widgetAddModalLocationFloorCheckbox'
                  onChange={(e) => 
                    handleItemSelectionToggle(e, floor.id)
                  }
                  checked={floor.id === tagid}
                  disabled={widgetConfig_result[selectedApp?.name]?.includes(floor.id)}
                  value={floor.id}
                  style={{
                    marginRight: "10px",
                    width: "20px",
                    height: "20px",
                    borderColor: "#6F7171",
                  }} /> {floor.name}
                </div>
                : floor.name}>
                {siteTagList?.areas.map((area) => {
                  if (area?.tagids?.includes(floor.id) && listTags?.includes(area.id)) {
                    return (
                      <TreeItem itemId={area.id} label={tagsIds.includes(area.id) ?
                        <div>
                          <input type="checkbox"
                          data-testid= 'dashboard_widgetAddModalLocationAreaCheckbox'
                         onChange={(e) => 
                          handleItemSelectionToggle(e, area.id)
                        }
                        checked={area.id === tagid}
                        disabled={widgetConfig_result[selectedApp?.name]?.includes(area.id)}
                        value={area.id}
                          style={{
                            marginRight: "10px",
                            width: "20px",
                            height: "20px",
                            borderColor: "#6F7171",
                          }} /> {area.name}
                        </div>
                        : area.name}>
                        {siteTagList?.subareas.map((subarea) => {
                          if (subarea?.tagids?.includes(area.id) && listTags?.includes(subarea.id)) {
                            return (
                              <TreeItem
                                itemId={subarea.id}
                                label={tagsIds.includes(subarea.id) ?
                                  <div>
                                    <input type="checkbox"
                                    data-testid= 'dashboard_widgetAddModalLocationSubAreaCheckbox'
                                    onChange={(e) => 
                                      handleItemSelectionToggle(e, subarea.id)
                                    }
                                    checked={subarea.id === tagid}
                                    value={subarea.id}
                                    disabled={widgetConfig_result[selectedApp?.name]?.includes(subarea.id)}
                                    style={{
                                      marginRight: "10px",
                                      width: "20px",
                                      height: "20px",
                                      borderColor: "#6F7171",
                                    }} /> {subarea.name}
                                  </div>
                                  : subarea.name}
                              ></TreeItem>
                            );
                          }
                        })}
                      </TreeItem>
                    );
                  }
                })}
              </TreeItem>
            );
          }
        })}
      </SimpleTreeView>
    </Box>
  );
}
